import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-line text-lg text-background-50"></i>
                </div>
                <span className="text-lg font-heading font-semibold text-background-50">
                  91精品视频
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                精选高分电影和热门电视剧，助你告别片荒。每日更新精品推荐，全站高清画质流畅播放，必看影视一网打尽。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                影视分类
              </h4>
              <ul className="space-y-2">
                {[
                  { name: '动作片', path: '/category/dongzuo' },
                  { name: '喜剧片', path: '/category/xiju' },
                  { name: '科幻片', path: '/category/kehuan' },
                  { name: '爱情片', path: '/category/aiqing' },
                  { name: '剧情片', path: '/category/juqing' },
                ].map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                热门推荐
              </h4>
              <ul className="space-y-2">
                {[
                  { name: '肖申克的救赎', path: '/article/xiao-shen-ke-de-jiu-shu' },
                  { name: '盗梦空间', path: '/article/dao-meng-kong-jian' },
                  { name: '三体', path: '/article/san-ti' },
                  { name: '流浪地球2', path: '/article/liu-lang-di-qiu-2' },
                  { name: '千与千寻', path: '/article/qian-yu-qian-xun' },
                ].map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                关于我们
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    联系我们
                  </Link>
                </li>
              </ul>
              <div className="mt-4">
                <p className="text-sm text-background-400">
                  邮箱：contact@91jingpin.com
                </p>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; 2020-2026 91精品视频在线播放 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-400 hover:text-background-50 transition-all duration-200"
                rel="nofollow"
                aria-label="微博"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-400 hover:text-background-50 transition-all duration-200"
                rel="nofollow"
                aria-label="微信"
              >
                <i className="ri-wechat-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-400 hover:text-background-50 transition-all duration-200"
                rel="nofollow"
                aria-label="B站"
              >
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}